import { render, staticRenderFns } from "./ProduzioneLayoutRow.vue?vue&type=template&id=14c989da&scoped=true&"
import script from "./ProduzioneLayoutRow.vue?vue&type=script&lang=js&"
export * from "./ProduzioneLayoutRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c989da",
  null
  
)

export default component.exports